<template>
  <div>
    <h1 class="m0 h4 regular">404</h1>
    <p class="m0">Not found</p>
  </div>
</template>

<script>
  export default {
    name: 'not-found'
  }
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue